import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UserDetailComponent } from '../../user/user-detail/user-detail.component';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../../shared/user.service';
import { TripService } from '../../service/trip.service';
import { Cycle, Payment, Site } from '../../model/trip';
import { ActivatedRoute } from '@angular/router';

@Component({
  providers: [UserDetailComponent],
  selector: 'TripPaymentCardsDetailsVFSuccess',
  templateUrl: './TripPaymentCardsDetailsVFSuccess.component.html',
  styleUrls: ['./TripPaymentCardsDetailsVFSuccess.component.css']
})
export class TripPaymentCardsDetailsVFSuccessComponent implements OnInit {

  userDetails: any = null;
  msgs: any[] = [];


  
  constructor(private userService: UserService, private tripService: TripService, private route:ActivatedRoute) { }

  ngOnInit() {
    this.userService.getUserClaims().subscribe((result: any) => {
      this.userDetails = result;

      let pid:number = this.route.snapshot.params['pid'];
      let catid:number = this.route.snapshot.params['catid'];
      if (catid==0) {catid = null;}
      let sid:number = this.route.snapshot.params['sid'];
      let cid:number = this.route.snapshot.params['cid'];
      if (cid==0) {cid = null;}
      let statusid:number = this.route.snapshot.params['statusid'];
      if (statusid==0) {statusid = null;}
      let grouper:string = this.route.snapshot.params['grouper'];
      if (grouper=='null') {grouper=null;}

      this.vfCollect(pid, catid, sid, cid, statusid, grouper);

    },
    (err: HttpErrorResponse) => {
      this.userDetails = null;
      this.showMessage('error', '', 'שגיאה בקבלת הרשאות');
    });
  }

  vfCollect(pid: number, catid: number, sid: number, cid: number, statusid: number, grouper: string) {
    let res = {catid: catid, sid:sid, cid: cid, statusid: statusid, grouper: grouper, resCode: '0'};
    
    this.tripService.changeCardCollect2(pid, cid, sid, catid, statusid, grouper).subscribe((result: any) => {
      res.resCode = '1';
      sessionStorage.setItem('resCode', JSON.stringify(res));

      //let url = `trip-cycles-2/${catid}/${sid}/${cid}/${statusid}/${grouper}`
      let url = `trip-cycles-2`;
      window.location.href = url;
      
      
    },
      (err: HttpErrorResponse) => {
        res.resCode = '2';
        sessionStorage.setItem('resCode', JSON.stringify(res));
        //let url = `trip-cycles-2/${catid}/${sid}/${cid}/${statusid}/${grouper}`
        let url = `trip-cycles-2`;
        window.location.href = url;
    });
  }


  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }


  
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/tip-card-change/TripPaymentCardsDetailsVFSuccess/TripPaymentCardsDetailsVFSuccess.component.ts